import KnowledgeBase from "@/svg/FlowSvg/KnowledgeBase.vue";

export default {
  FileUploadSizeLimit: '文件大小需小于 10MB!',
  FileEncoding: '文件编码错误，请保存为utf-8格式后上传， 或联系客服处理',
  TokenLimit: '大小超限，单个应用token数不超过100w，额外需求请联系客服',
  KnowledgeBaseUpdating: '知识库更新中，请稍等~',
  FileTypeError: '请上传 txt, pdf, md, docx 格式文件',
  CSVFormatError: '请上传 csv 格式文件',
  FileName: '文件名',
  FileType: '文件类型',
  FileSize: '文件大小 (KB)',
  KnowledgeBaseCount: '知识库条数',
  UpdateTime: '更新时间',
  Operation: '操作',
  View: '查看',
  Create: '新增',
  Edit: '编辑',
  Export: '导出',
  Preview: '预览',
  Delete: '删除',
  Rename: '重命名',
  CreateFile: '创建新文件',
  ImportFile: '导入文件',
  ImportType: '导入方式',
  ImportTypeTooltip: '导入方式：',
  Import: '导入',
  ManualCreate: '手动创建',
  Document: '文档',
  QA: '问答',
  Table: '表格',
  Website: '网页',
  SearchPlaceholder: '请输入搜索内容',
  Refresh: '刷新',
  DeleteConfirm: '将从知识库中删除该文件的数据',
  DeleteFile: '删除文件',
  ConfirmDelete: '确认删除',
  DeleteSuccess: '删除成功',
  CancelDelete: '取消删除',
  PleaseEnterFileName: '请输入文件名称',
  CreateSuccess: '创建成功',
  ModifyName: '修改名称',
  Cancel: '取消',
  Confirm: '确定',
  All: '全部',
  Status: '状态',
  Effective: '生效',
  Failed: '失败',
  Processing: '处理中',
  FileExporting: '知识库文件导出中，数据处理需要一定时间，请耐心等待~',
  CreateNewFile: '创建新文件',
  SerialNumber: '序号',
  Tokens: 'tokens',
  ManualCreation: '手动创建',
  SelectFileType: '选择文件类型',
  CreateTable: '表格',
  ExcelIcon: '表格图标',
  UploadFile: '上传文件',
  UploadFileTooltip: '上传文件：',
  FileNameRequired: '文件名称不能为空',
  FileNameTooLong: '文件名称不能超过50个字符',
  FileNameInvalid: '文件名称只能包含字母、数字、下划线和连字符',
  Type: '类型',
  Add: '新增',
  Back: '返回',
  Content: '内容',
  Question: '问题',
  QuestionTooltip: '问题：',
  Answer: '答案',
  AnswerTooltip: '答案：',
  dragAndDropFile: '拖入文件',
  clickToUpload: '点击上传',
  UploadTip: '支持图片、视频、文件，单个不超过15M',
  SearchMethod: '检索方式',
  SearchMethodTooltip: '在语义检索时，只检索问题的语义相似度，或是同时检索问题和答案的语义相似度',
  QuestionOnly: '只检索问题',
  QuestionAndAnswer: '同时检索问题和答案',
  PreviewFile: '预览文件',
  AddMaterial: '添加素材',
  AddMaterialTip: '上传后素材将以链接的形式自动添加到答案内容中',
  DeleteData: '删除数据',
  DeleteDataConfirm: '从文件中删除该条数据',
  ConfirmDeleteBtn: '确认删除',
  CancelDeleteBtn: '取消',
  DeleteSuccessMsg: '删除成功',
  CancelDeleteMsg: '取消删除',
  EnterContent: '请输入内容',
  EnterQuestion: '请输入问题',
  EnterAnswer: '请输入答案',
  FileUploadSuccess: '文件{filename}上传成功',
  Total: '共{count}条',
  PleaseWait: '请稍后~',
  KnowledgeBaseName: '知识库名称：',
  KnowledgeBaseCode: '知识库Code：',
  KnowledgeBaseDescription: '知识库描述：',
  PleaseEnterKnowledgeBaseName: '请输入知识库名称：',
  PleaseEnterKnowledgeBaseDescription: '请输入知识库描述',
  KnowledgeBaseSaveSuccess: '知识库保存成功',
  DeleteKnowledgeBase: '删除知识库',
  DeleteKnowledgeBaseConfirm: '将删除该知识库中所有文件以及与应用的绑定关系，是否确认？',
  AutoParseDocuments: '自动解析无结构文档, 使用方便',
  qaImport: '一问一答导入, 准确性更佳',
  StructuredTableImport: '结构化表格导入, 支持多列检索',
  WebImport: '自动获取网页内容导入',
  ImportIndependentWebsite: '导入独立网址',
  ImportBasedOnWebsiteMap: '基于网站地图导入',
  ImportBasedOnWebsiteMapTooltip: '根据网站根地址或网站地图自动获取网站下所有页面的内容',
  WebsiteAddress: '网页地址',
  WebsiteAddressTooltip: '网页地址：',
  CurrentVersionLimit: '当前版本单次可添加{count}个网址（含深度解析的子页面）',
  CurrentVersionLimitTooltip: '当前版本单次可获取网站地图下前{count}个页面的内容',
  InputWebsiteAddress: '输入网站根地址，或网站地图 (sitemap.xml) 的URL',
  BatchInputWebsiteAddress: '可批量输入网址（以http或https开头），用换行分隔',
  DeepParsing: '深度解析',
  DeepParsingTooltip: '自动解析页面中的子链接并获取内容，一键导入网页及其子页面',
  ImportFeishu: '导入飞书',
  ImportFeishuTooltip: '暂不支持飞书多维表格',
  FeishuAuthorization: '飞书授权',
  ViewAuthorization: '查看授权',
  GoAuthorization: '去授权',
  SupportFileFormat: '支持 txt, pdf, md, docx格式文件, 单次最多上传{count}个文件，单个大小不超过{size}M',
  SupportCsvFileFormat: '支持 csv(双列) 格式文件, 单次可上传{count}个文件，单个大小不超过{size}M',
  UploadFileFormat: '上传文件需和模板文件格式一致（CSV UTF-8格式）',
  DownloadCsvTemplate: '下载CSV模板',
  supportCsvXlsxFormat: '支持 csv (UTF-8) 格式, xlsx 格式文件, 请上传1个文件，大小不超过{count}M，单次导入表格数据行数不超过{size}行',
  CloudDocumentAddress: '云文档地址',
  OnlineTableAddress: '在线表格地址',
  CloudDocumentAddressTooltip: '云文档地址：',
  OnlineTableAddressTooltip: '在线表格地址：',
  CurrentVersionLimitCloudDocument: '当前版本单次可添加{count}个飞书云文档',
  CurrentVersionLimitOnlineTable: '单个表格数据行不超过{size}行',
  InputSingleFeishuWordAddress: '输入单个飞书表格地址（以https开头）',
  BatchInputDocumentAddress: '可批量输入文档地址（以https开头），用换行分隔',
  EnhancedParsing: '增强解析',
  EnhancedParsingTooltip: '解析pdf、docx文档中的图片和表格内容导入知识库',
  Parsing: '解析中',
  ParsingFailed: '该网页不支持导入',
  ParseLength: '分段长度',
  CurrentSegment: '当前分段：',
  SearchStrategy: '检索策略：',
  SearchStrategyTooltip: '只检索问题：只能根据问题中的相关文本找到这条语料，但检索的相似度更高',
  SearchStrategyTooltip2: '同时检索问题和答案：可以根据问题或答案中的相关文本找到这条语料，但检索的相似度会下降',
  PreviewAfterImportDocuments: '导入文档后预览',
  PreviewAfterImportQuestionsAndAnswers: '导入问答后预览',
  PreviewAfterImportTables: '导入表格后预览',
  PreviewAfterImportWebsites: '导入网页后预览',
  SegmentPreview: '分段预览',
  SegmentPreviewTooltip: '当前预览仅展示前50个段落',
  Segment: '分段',
  Index: '索引',
  IndexColumn: '索引列',
  IndexColumnTooltip: '是否参与索引：勾选后用户问题会与该列内容进行语义相似度/关键词检索匹配',
  IndexColumnTooltipTips: '提示：',
  IndexColumnTooltipTips1: '1、索引列确定后不能再修改',
  IndexColumnTooltipTips2: '2、模型推理时会参考列名，可修改列名，列名不能重复',
  IndexColumnTooltipTips3: '3、用户提问匹配到索引列中的某个值时，该值所在的整行数据会作为知识库命中内容', 
  TotalRecords: '总计{count}条记录，当前预览仅展示前50行',
  SingleFileParagraphs: '单文件段落数：',
  SingleFileTokens: '单文件token数：',
  SingleFilePrice: '单文件价格：',
  EstimatedTotalPrice: '预估总价格：',
  Points: '积分',
  CancelImport: '取消导入',
  RePreview: '重新预览',
  ConfirmImport: '确定导入',
  UseTips: '使用提示',
  UseTipsContent: '使用"网站导入"功能时，您提交的网站地址应为您有权支配或使用的自有或第三方网址，并对提交网址内容的合法性承担全部责任。平台仅提供网站解析导入服务，不对您使用网址数据的行为承担任何责任。建议导入博客、公众号文章、官网文字信息页、使用说明页等静态网站，暂不支持部分国内媒体网站。',
  UseTipsContent2: '建议导入博客、公众号文章、官网文字信息页、使用说明页等静态网站，暂不支持部分国内媒体网站。',
  IAgree: '我同意',
  SelfBuiltApplicationAuthorization: '自建应用授权',
  PleaseUploadCsvTxtPdfMdDocxFormatFile: '请上传 csv, txt, pdf, md, docx 格式文件',
  PleaseUploadCsvFormatFile: '请上传 csv 格式文件',
  PleaseUploadCsvOrXlsxFormatFile: '请上传 csv 或 xlsx 格式文件',
  FileSizeMustBeLessThan: '文件大小需小于',
  UploadFailed: '上传失败',
  PleaseReLogin: '请重新登录',
  PointsNotEnough: '积分不足',
  CurrentFileNotParsed: '当前有文件还未解析完成，是否继续导入?',
  CancelImportFile: '取消导入',
  ConfirmImportFile: '确定导入',
  KnowledgeBaseFileImporting: '知识库文件导入中，数据处理需要一定时间，请耐心等待~',
  ImportFileSuccess: '文件提交成功，数据正在加速处理中，可以点击刷新按钮查看最新状态',
  FileUploading: '文件正在上传，请稍后！',
  FileParsing: '文件正在解析，请稍后！',
  BindSuccess: '绑定成功',
  PleaseInputSingleFeishuTableAddress: '请输入单个飞书表格地址',
  PleaseInputDocumentAddress: '请输入文档地址',
  PleaseSelectImportMethod: '请选择导入方式',
  PleaseEnterTheXMLAddress: '请输入XML地址',
  PleaseEnterTheWebsiteDomainName: '请输入网站域名',
  Image: '图片',
  Video: '视频',
  File: '文件',
  Miniprogram: '小程序',
  Card: '卡片',
  Upload: '上传',
  MediaResource: {
    Name: '名称',
    Type: '类型',
    Size: '大小 (KB)',
  },
  UploadMaterial: '上传素材',
  FileRenameSuccess: '文件名修改成功',
  DeleteFileConfirm: '是否确认删除该文件?',
  CopySuccess: '复制成功',
  CopySuccessMsg: '复制成功，加入知识库中即可生效',
  TestText: '测试文本',
  PleaseEnterTheQuestionToBeSearched: '请输入需要检索的问题',
  Retrieval: '检索',
  RetrievalResult: '检索结果',
  RetrievalResultTips: '1. 此处展示语义检索与全文检索的结果各10条，实际使用时将根据知识库中增强检索的策略配置叠加两种结果（去重）输出',
  RetrievalResultTips2: '2. 若内容中无匹配的关键词，则全文检索结果可能不存在；若匹配到的内容有限，则可能不足10条',
  SemanticRetrievalResult: '语义检索结果',
  NoResult: '暂无结果',
  Similarity: '相似度：',
  WebsiteImport: '网站导入',
  FullTextRetrievalResult: '全文检索结果',
  Sort: '排序：',
  Retrieving: '检索中，请耐心等待~',
  CreateKnowledgeBase: '创建知识库',
  PleaseGiveEnterKnowledgeBaseName: '给你的知识库取一个名字吧',
  KnowledgeBaseNeedToBeBoundToKnowledgeApplication: '知识库需绑定到知识应用才可生效',
  PleaseFillInTheContent: '请填写内容',
  AddSuccess: '新增成功',
  AddFailed: '新增失败',
  removeDataFromFile: '从文件中删除该条数据。',
  modificationSuccess: '修改成功',
  modificationFailed: '修改失败',
  FileManagement: '文件管理',
  FileImport: '文件导入',
  MediaManagement: '素材管理',
  RetrievalTest: '检索测试',
  Configuration: '配置',
  HowToChoose: '如何选择',
  ImportMethod: '导入方式',
  HowToChooseImportMethod: '如何选择 ',
  maxUploadFilesPerSession: '单次最多上传{count}个文件',
  maxImportCount: '单次导入最多可添加{count}个飞书云文档',
  maxImportUrls: '单次导入最多可添加{count}个网址',
  RetrievalMode: "检索测试",
  SearchKnowledgeContent: '搜索文件内容'
}


